import React from "react";

import { Button } from "ii-ui-kit";

import "./info-page.scss";

export const InfoPage = () => {
  const goToMain = () => {
    window.location.replace("https://lk.ingosinvest.ru");
  };

  return (
    <div className="info-page">
      <div className="info-page__title">Вы уже авторизованы</div>
      <Button
        className={"info-page__button"}
        title={"Вернуться в личный кабинет"}
        size={"l"}
        onClick={goToMain}
      />
    </div>
  );
};
